import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.scss';
import { HomepageIcon } from './../../ui/Icons/HomepageIcon';

const Breadcrumbs = () => {
  const location = useLocation();

  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <nav className="breadcrumbs">
      <Link to="/" className='homepage-icon' title='Homepage'>
        <HomepageIcon />
      </Link>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;

        return isLast ? (
          <span key={to}> / {decodeURI(value)}</span>
        ) : (
          <span key={to}> / <Link to={to}>{decodeURI(value)}</Link></span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;

